import { render } from "./routeWithSidebar.vue?vue&type=template&id=43770eb4&lang=pug"
import script from "./routeWithSidebar.vue?vue&type=script&lang=js"
export * from "./routeWithSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__